import React from "react";

// ระดับความสัมพันธ์ (ตรงกับ gs/Ai.gs) — ใช้อัปเดตป้ายทันทีหลังส่งข้อความ
export const ROMANTIC_LEVELS = [[0, "เฉยๆ"], [100, "หวั่นไหว"], [300, "คนคุย"], [600, "แฟน"], [900, "แต่งงาน"]];
export const INTIMACY_LEVELS = [[-1000, "คู่อริ"], [-200, "เกลียด"], [0, "คนรู้จัก"], [100, "เพื่อน"], [300, "เพื่อนสนิท"], [700, "เพื่อนตาย"]];
export const levelLabel = (levels, v) => {
  let out = levels[0][1];
  levels.forEach(([min, name]) => { if (v >= min) out = name; });
  return out;
};

export const TYPING_PHRASES = [
  "แป๊บนะ... กำลังนึกหาคำที่ใช่สุด ๆ อยู่",
  "กำลังพิมพ์อยู่นะ รอแป๊บนึง",
  "ขอคิดแป๊บ... อยากตอบให้ดีที่สุด",
];

/** แทนตัวแปรในข้อความ ({{user}} {{char}}) ตอนแสดงผล */
export const fillVars = (text, userName = "คุณ", charName = "") =>
  String(text || "").replaceAll("{{user}}", userName).replaceAll("{{char}}", charName);

/** *การกระทำ* เป็นตัวเอียง, ที่เหลือเป็นบทพูด */
export const renderContent = (text) =>
  String(text || "").split(/(\*[^*]+\*)/g).map((part, i) =>
    part.startsWith("*") && part.endsWith("*") && part.length > 2 ? <em key={i}>{part.slice(1, -1)}</em> : <React.Fragment key={i}>{part}</React.Fragment>
  );

export const timeOf = (iso) => (iso ? new Date(iso).toLocaleTimeString("th-TH", { hour: "2-digit", minute: "2-digit" }) : "");

const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
export const dayLabel = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Math.round((dayStart(new Date()) - dayStart(d)) / 864e5);
  if (diff === 0) return "วันนี้";
  if (diff === 1) return "เมื่อวาน";
  return d.toLocaleDateString("th-TH", { day: "numeric", month: "short", year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric" });
};
export const sameDay = (a, b) => new Date(a).toDateString() === new Date(b).toDateString();

export const MODEL_CATEGORIES = [
  { value: "all", label: "ทั้งหมด" },
  { value: "chat", label: "คุยเอไอ" },
  { value: "novel", label: "นิยาย" },
  { value: "economy", label: "ประหยัด/พื้นฐาน" },
];

export const UNAVAILABLE = "ยังไม่เปิดให้บริการ";
